// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { authApi } from "../../config/api"; // Assuming authApi is a configured axios instance
// import { toast } from "react-toastify";

// // Async thunk to post a bug report
// export const reportBug = createAsyncThunk(
//   "bugs/reportBug",
//   async (bugData, { rejectWithValue }) => {
//     try {
//       const response = await authApi.post("/manager/bugs/", bugData);
//       toast.success("Bug reported successfully!");
//       return response.data;
//     } catch (error) {
//       toast.error("Failed to report the bug. Please try again.");
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// const bugSlice = createSlice({
//   name: "bugs",
//   initialState: {
//     loading: false,
//     error: null,
//     bugs: [],
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(reportBug.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(reportBug.fulfilled, (state, action) => {
//         state.loading = false;
//         state.bugs.push(action.payload);
//       })
//       .addCase(reportBug.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default bugSlice.reducer;



import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../config/api"; // Assuming authApi is a configured axios instance
import { toast } from "react-toastify";

// Async thunk to post a bug report
export const reportBug = createAsyncThunk(
  "bugs/reportBug",
  async (bugData, { rejectWithValue }) => {
    console.log(bugData);

    try {
      const response = await authApi.post("/manager/bugs/", bugData);
      console.log(response.data);
      toast.success("Bug reported successfully!");
      return response.data;
    } catch (error) {
      toast.error("Failed to report the bug. Please try again.");
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk to fetch bug reports
export const fetchBugReports = createAsyncThunk(
  "bugs/fetchBugReports",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.get("/manager/bug-reports/");
      return response.data;
    } catch (error) {
      //   toast.error("Failed to fetch bug reports.");
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk to delete a bug report
export const deleteBugReport = createAsyncThunk(
  "bugs/deleteBugReport",
  async (bugId, { rejectWithValue }) => {
    try {
      const response = await authApi.delete(`/manager/bug-report/${bugId}/`);
      toast.success("Bug report deleted successfully!");
      return response.data;
    } catch (error) {
      toast.error("Failed to delete the bug report.");
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk to edit a bug report
export const editBugReport = createAsyncThunk(
  "bugs/editBugReport",
  async ({ bugId, updatedData }, { rejectWithValue }) => {
    try {
      const response = await authApi.put(
        `/manager/bug-report/${bugId}/`,
        updatedData
      );
      toast.success("Bug report updated successfully!");
      return response.data;
    } catch (error) {
      toast.error("Failed to update the bug report.");
      return rejectWithValue(error.response.data);
    }
  }
);

const bugSlice = createSlice({
  name: "bugs",
  initialState: {
    loading: false,
    error: null,
    bugs: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle reportBug actions
      .addCase(reportBug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportBug.fulfilled, (state, action) => {
        state.loading = false;
        state.bugs.push(action.payload);
      })
      .addCase(reportBug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle fetchBugReports actions
      .addCase(fetchBugReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBugReports.fulfilled, (state, action) => {
        state.loading = false;
        state.bugs = action.payload;
      })
      .addCase(fetchBugReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle deleteBugReport actions
      .addCase(deleteBugReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBugReport.fulfilled, (state, action) => {
        state.loading = false;
        state.bugs = state.bugs.filter(
          (bug) => bug.ticket_number !== action.payload.ticket_number
        );
      })
      .addCase(deleteBugReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle editBugReport actions
      .addCase(editBugReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBugReport.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.bugs.findIndex(
          (bug) => bug.ticket_number === action.payload.ticket_number
        );
        if (index !== -1) {
          state.bugs[index] = action.payload;
        }
      })
      .addCase(editBugReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bugSlice.reducer;
